import 'core-js/stable';
import 'react-toastify/dist/ReactToastify.min.css';
import './helpers/initialize-client-shared';
import './styles/index.scss';
import { initializeAxiosRequestInterceptor } from '@sit/client-shared';
import { TanStackDevtools } from '@tanstack/react-devtools';
import { formDevtoolsPlugin } from '@tanstack/react-form-devtools';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtoolsPanel } from '@tanstack/react-query-devtools';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import AppRouter from './containers/App';
import { queryClient } from './query';

const LOADING_SCREEN_SELECTOR = 'assets-loading';
const HIDE_CLASS = 'hide';

function hideLoadingScreen() {
  const loadingScreen = document.getElementsByClassName(
    LOADING_SCREEN_SELECTOR,
  )[0];
  loadingScreen?.classList.add(HIDE_CLASS);
}

async function enableMocking() {
  if (
    import.meta.env.NODE_ENV !== 'development' ||
    import.meta.env.VITE_APP_MSW_DISABLED
  ) {
    return;
  }
  const { worker } = await import('./__mocks__/browser');
  return await worker.start({
    onUnhandledRequest: 'bypass',
    quiet: import.meta.env.VITE_APP_LOG_MSW !== 'true',
  });
}

hideLoadingScreen();
initializeAxiosRequestInterceptor();

const root = createRoot(document.getElementById('root')!);

void enableMocking().then(() => {
  root.render(
    <StrictMode>
      <QueryClientProvider client={queryClient}>
        <AppRouter />
        <TanStackDevtools
          plugins={[
            {
              name: 'Query',
              render: <ReactQueryDevtoolsPanel />,
            },
            {
              name: 'Form',
              render: formDevtoolsPlugin().render,
            },
          ]}
        />
      </QueryClientProvider>
      ,
    </StrictMode>,
  );
});

if (import.meta.env.NODE_ENV === 'development') {
  import('./reportWebVitals')
    .then(({ reportWebVitals }) => reportWebVitals(console.log))
    .catch((error) => {
      console.error('Failed to load reportWebVitals', error);
    });
}
